module.exports = __webpack_public_path__ + "img/lock.9b5266f9.jpg";